import _ from 'lodash';
import { useEffect, useState } from 'react';

import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { SHOW_COMMEMORATE } from 'src/constants';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import { convertObjPath, timestamp } from 'src/utils/helper';
import { GET } from 'src/utils/services';
const SectionV = dynamic(import('src/components/sections/section-v'), { ssr: false });
const SectionH = dynamic(import('src/components/sections/section-h'), { ssr: false });
const SectionHSide = dynamic(import('src/components/sections/section-h-side'), { ssr: false });

const SectionFour = ({ bookcase }) => {
  const [sectionFourData, setSectionFourData] = useState(null);
  const router = useRouter();

  useEffect(() => {
    (async () => {
      try {
        const response = await GET(
          `/api/v1.0/home/section-five${convertObjPath({
            block1: 5,
            block2: 4,
            block3: 4
          })}`
        );
        if (!_.isEmpty(response)) setSectionFourData(response);
      } catch (err) {
        console.error(`${timestamp()} ==========> SECTION_FIVE ERROR :`, err.message);
      }
    })();
  }, []);

  return (
    <>
      <section id='section-9' className='container' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
        {!_.isEmpty(sectionFourData) && (
          <div className='row'>
            {!_.isEmpty(sectionFourData?.block1?.data) && (
              <div className='col-lg-8 col-md-12'>
                {sectionFourData !== null && (
                  <SectionHSide
                    data={sectionFourData.block1}
                    path={sectionFourData.block1.link}
                    heading={sectionFourData.block1.title}
                    //! DATALAYER
                    eventDataLayer={{
                      type: DATALAYER_TYPE.TRACK_POSITION,
                      router: router?.pathname,
                      section: 'section-9',
                      position: 'ใต้:section-8',
                      data: {
                        block: '1',
                        heading: sectionFourData.block1.title
                      }
                    }}
                  />
                )}
              </div>
            )}

            {!_.isEmpty(sectionFourData?.block2?.data) && (
              <div className={`${sectionFourData.block1.data.length < 1 ? 'col-12' : 'col-lg-4 col-sm-12'}`}>
                <SectionH
                  data={sectionFourData.block2.data}
                  path={sectionFourData.block2.link}
                  heading={sectionFourData.block2.title}
                  //! DATALAYER
                  eventDataLayer={{
                    type: DATALAYER_TYPE.TRACK_POSITION,
                    router: router?.pathname,
                    section: 'section-9',
                    position: 'ใต้:section-8',
                    data: {
                      block: '2',
                      heading: sectionFourData.block2.title
                    }
                  }}
                />
              </div>
            )}
          </div>
        )}
      </section>
      <section id='section-10' className='container' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
        <div className={'col-12'}>
          {!_.isEmpty(sectionFourData?.block3?.data) && (
            <SectionV
              data={sectionFourData.block3.data}
              path={sectionFourData.block3.link}
              heading={sectionFourData.block3.title}
              //! DATALAYER
              eventDataLayer={{
                type: DATALAYER_TYPE.TRACK_POSITION,
                router: router?.pathname,
                section: 'section-10',
                position: 'ใต้:section-9',
                data: {
                  heading: sectionFourData.block3.title
                }
              }}
            />
          )}
        </div>
      </section>
    </>
  );
};

export default SectionFour;
